import { PrismaticEmbed } from 'components/gms/PrismaticEmbed';
import { showPrismatic } from 'services/prismaticService';

export const IntegrationsMarketplace = () => (
  <PrismaticEmbed
    embedFunction={showPrismatic}
    containerId="prismatic-marketplace"
  />
);
